import { request, buildQuery } from '../../lib/apiClient';
export function listCustomers(params) {
    const query = buildQuery({
        type: params?.type,
        status: params?.status,
        name: params?.name,
        city: params?.city,
        zip: params?.zip,
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/customers${query}`);
}
export function getCustomer(id) {
    return request(`/customers/${id}`);
}
export function createCustomer(input) {
    return request('/customers', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function updateCustomer(id, input) {
    return request(`/customers/${id}`, {
        method: 'PUT',
        body: JSON.stringify(input),
    });
}
export function updateCustomerStatus(id, status) {
    return request(`/customers/${id}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status }),
    });
}
export function addNote(customerId, input) {
    return request(`/customers/${customerId}/notes`, {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function listNotes(customerId, params) {
    const query = buildQuery({
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/customers/${customerId}/notes${query}`);
}
//# sourceMappingURL=api.js.map